import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, B1, BlueButton } from '../../StyledComponents';
import KioskMob from '../../../assets/v2/manage/kiosk_mobile.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import RetailMob from '../../../assets/v2/manage/retail.svg';
import { Link, graphql, StaticQuery } from 'gatsby';
import GatsbyImage from 'gatsby-image';

const Section = styled(SectionParent)``;
const SectionContainer = styled.div`
  padding-left: 2rem;
  padding-right: 2rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-left: 0rem;
    padding-right: 0rem;
    grid-gap: 1rem;
  }
  display: grid;
  grid-gap: 5rem;
  padding-top: 5rem;
  padding-bottom: 5rem;
`;

const Card = styled.div`
  border-radius: 4px;
  box-shadow: 0 2px 13px 0 rgba(51, 41, 85, 0.2);
  background-color: #ffffff;
  display: grid;
  min-height: 400px;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 520px) {
    padding: 1rem;
    grid-template-columns: repeat(1, 1fr);
  }
`;

const CardImg = styled(GatsbyImage)`
  max-height: 100%;
  max-width: 100%;
  grid-column: span 1;
  /* img {
    object-fit: contain !important;
  } */
  @media (max-width: 520px) {
    display: none;
  }
`;

const CardImgRight = styled(GatsbyImage)`
  max-height: 100%;
  max-width: 100%;
  grid-column: span 1;
  /* img {
    object-fit: contain !important;
  } */
  @media (max-width: 520px) {
    display: none;
  }
`;

const CardContentLeft = styled.div`
  padding: 3rem;
  padding-left: 1rem;
  grid-column: span 2;
  align-self: center;

  @media (max-width: 520px) {
    padding: 1rem;
    display: grid;
    justify-items: center;
  }
`;

const CardContentRight = styled.div`
  padding: 3rem;
  padding-right: 1rem;
  align-self: center;
  grid-column: span 2;
  @media (max-width: 520px) {
    padding: 1rem;
    display: grid;
    justify-items: center;
  }
`;

const CardTitle = styled(H1)`
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 1rem;
  color: #725cbd;
`;

const CardDescription = styled(B1)`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: justify;
  color: #7f8495;

  @media (max-width: 520px) {
    text-align: center;
  }
}`;

const CardLearnMore = styled(BlueButton)`
  color: #39415d;
  margin-top: 2rem;
  background: #e3ebfb;
  :hover {
    color: #39415d;
    background-color: #c8d8f7;
  }
  margin-bottom: 0rem;
  margin-left: 0rem;

  @media (max-width: 520px) {
    text-align: center;
  }
`;

const CardImgMobile = styled(LazyLoadImage)`
  display: none;

  @media (max-width: 520px) {
    display: unset;
    align-self: center;
    justify-self: center;
    max-width: 50%;
    margin-top: 2rem;
  }
`;

const EsperManageSections = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          kioskLeft: file(relativePath: { eq: "v2/manage/group-2363@3x.png" }) {
            childImageSharp {
              fluid(quality: 95) {
                aspectRatio
                src
                srcSet
                sizes
                srcWebp
                srcSetWebp
              }
            }
          }

          retailRight: file(
            relativePath: { eq: "v2/manage/group-2363-copy@3x.png" }
          ) {
            childImageSharp {
              fluid(quality: 95) {
                aspectRatio
                src
                srcSet
                sizes
                srcWebp
                srcSetWebp
              }
            }
          }
        }
      `}
      render={(data: any) => (
        <Section>
          <SectionContainer>
            <Card>
              <CardImg
                fluid={data.kioskLeft.childImageSharp.fluid}
                alt="KioskLeft"
                loading="lazy"
              />
              <CardImgMobile src={KioskMob} />
              <CardContentLeft>
                <CardTitle>Kiosks</CardTitle>
                <CardDescription>
                  Industry’s first full-stack solution for Kiosks. Dynamically
                  lock down your kiosks and significantly improve operational
                  efficiency and performance.
                </CardDescription>
                <Link to="/kiosk-device-management">
                  <CardLearnMore>Learn more</CardLearnMore>
                </Link>
              </CardContentLeft>
            </Card>
            <Card>
              <CardImgMobile src={RetailMob} />
              <CardContentRight>
                <CardTitle>Retail</CardTitle>
                <CardDescription>
                  Android Device Management platform that helps retailers
                  deploy, manage and monitor the modern retail experience
                  through touch-enabled devices.
                </CardDescription>
                <Link to="/retail-device-management">
                  <CardLearnMore>Learn more</CardLearnMore>
                </Link>
              </CardContentRight>
              <CardImgRight
                fluid={data.retailRight.childImageSharp.fluid}
                alt="Retail"
                loading="lazy"
              />
            </Card>
          </SectionContainer>
        </Section>
      )}
    />
  );
};

export default EsperManageSections;
